function initWellnessButtons() {
	const buttons = document.querySelectorAll(".btn");
	buttons.forEach(button => {
		const svg = button.querySelector("svg");
		if (!svg) {
			button.insertAdjacentHTML("beforeend", `<svg><use xlink:href="#check"></use></svg>`);
		}
	});
}
